import React from 'react';
import styled from 'styled-components';

// Styling for the timeline
const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const TimelineItem = styled.div`
  display: flex;
  width: 80%;
  margin: 20px 0;
  position: relative;
`;

const Timestamp = styled.div`
  flex: 1;
  text-align: right;
  padding-right: 20px;
  font-weight: bold;
`;

const Content = styled.div`
  flex: 3;
  background-color: #f0f0f0;
  padding: 15px;
  border-radius: 8px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: -10px;
    top: 15px;
    width: 20px;
    height: 20px;
    background-color: #007bff;
    border-radius: 50%;
  }
`;

const MediaWrapper = styled.div`
  margin-top: 10px;
  img, video {
    max-width: 100%;
    max-height: 300px;
    margin: 5px 0;
  }
`;

const Timeline = ({ events }) => {
    return (
        <TimelineContainer>
            {events.map((event, index) => (
                <TimelineItem key={index}>
                    <Timestamp>{event.timestamp}</Timestamp>
                    <Content>
                        <h3>{event.title}</h3>
                        <p>{event.description}</p>
                        <MediaWrapper>
                            {event.images.map((image, i) => (
                                <img key={i} src={image} alt={`event-${index}-${i}`} />
                            ))}
                            {event.videos.map((video, i) => (
                                <video key={i} controls>
                                    <source src={video} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            ))}
                        </MediaWrapper>
                    </Content>
                </TimelineItem>
            ))}
        </TimelineContainer>
    );
};

export default Timeline;